import React from "react";
import styled from "styled-components";
import $ from "jquery";

const ContactStepWrapper = styled.div`
  h4 {
    font-size: 26px;
    line-height: 35px;
    max-width: 400px;
    margin: 50px auto 60px;
    text-align: center;
    text-transform: none;
  }
  form {
    margin-bottom: 60px;
  }
`;

class ContactStep1 extends React.Component {
  inputControll() {
    $(".field-input").focus(function() {
      $(this)
        .parent()
        .addClass("is-focused has-label");
    });
    $(".field-input").blur(function() {
      const $parent = $(this).parent();
      if ($(this).val() === "") {
        $parent.removeClass("has-label");
      }
      $parent.removeClass("is-focused");
    });
  }

  componentDidMount() {
    this.inputControll();
  }

  render() {
    return (
      <ContactStepWrapper>
        <h4>Wypełnij formularz, aby poznać szczegóły naszej oferty.</h4>
        <form className="row" action="#" ref={this.textInput}>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="firstName" className="field-label">
                Imię
              </label>
              <input
                type="text"
                id="firstName"
                className="field-input"
                onChange={e => this.props.onChange("firstName", e.target.value)}
                value={this.props.values.firstName}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="lastName" className="field-label">
                Nazwisko
              </label>
              <input
                type="text"
                id="lastName"
                className="field-input"
                onChange={e => this.props.onChange("lastName", e.target.value)}
                value={this.props.values.lastName}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field">
              <label htmlFor="phone" className="field-label">
                Telefon
              </label>
              <input
                type="number"
                id="phone"
                className="field-input"
                onChange={e => this.props.onChange("phone", e.target.value)}
                value={this.props.values.phone}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="email" className="field-label">
                Adres Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                className="field-input"
                onChange={e => this.props.onChange("email", e.target.value)}
                value={this.props.values.email}
              />
            </div>
          </div>
        </form>
      </ContactStepWrapper>
    );
  }
}

export default ContactStep1;
